import { Button, CircularProgress, Typography } from '@mui/material';
import { styled } from '@mui/system';
import { MuiTelInput } from 'mui-tel-input';
import { useEffect, useState } from 'react';
import dropdownIcon from '../assets/svg/arrow_down.svg';

const StyledPhoneInput = styled(MuiTelInput)(({ theme }) => ({
  '& fieldset': {
    borderColor: theme.palette.border,
  },
  '& .MuiTelInput-Flag': {
    marginLeft: "-20px",
    marginRight: "-20px"
  },
  '& .MuiTelInput-Flag::after': {
    content: `url(${dropdownIcon})`,
    marginLeft: '10px',
  },
  '& .Mui-disabled .MuiTelInput-IconButton': {
    display: 'none',
  },
  '.MuiTelInput-IconButton': {
    margin: 10,
  },
  '& input': {
    fontSize: '16px',
    color: theme.palette.text.primary,
    WebkitTextFillColor: `${theme.palette.text.primary} !important`,
  },
  '& button': {
    borderColor: theme.palette.border,
  },
}));

export const PhoneField = ({
  initialPhoneNumber = '',
  loading = false,
  isVerified = false,
  initialError = '',
  onSubmit,
  onPhoneNumberChange = (phone) => { },
}) => {
  const [phoneNumber, setPhoneNumber] = useState(initialPhoneNumber);
  const [enableVerifyButton, setEnableVerifyButton] = useState(false);
  const [error, setError] = useState(initialError);

  useEffect(() => {
    setError(initialError);
  }, [initialError]);

  const handleChange = (newPhone, info) => {
    setError('');

    // Check if info object is valid
    if (!info || !info.nationalNumber) {
      return;
    }

    const isBrazil = info.countryCode === 'BR';
    const maxDigits = isBrazil ? 11 : 10;

    // Only update if within max digits limit
    if (info.nationalNumber.length <= maxDigits) {
      // Store the E164 formatted number (with country code)
      setPhoneNumber(info.numberValue || newPhone);
      onPhoneNumberChange(info.numberValue || newPhone);
    }
    
    // Enable verify button when we have at least 10 digits
    setEnableVerifyButton(info.nationalNumber.length >= 10);
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && enableVerifyButton && !isVerified) {
      e.preventDefault();
      onSubmit(phoneNumber);
    }
  };

  return (
    <StyledPhoneInput
      error={error?.length > 0}
      fullWidth={true}
      helperText={error}
      value={phoneNumber}
      label='Phone Number'
      defaultCountry='US'
      forceCallingCode
      focusOnSelectCountry={false}
      onChange={handleChange}
      onKeyDown={handleKeyDown}
      disabled={isVerified}
      autoFocus
      inputProps={{
        inputMode: 'tel',
        enterKeyHint: 'next',
        autoCapitalize: 'none',
        autoCorrect: 'off',
        'aria-label': 'Phone number'
      }}
      InputProps={{
        endAdornment: (
          <Button
            disabled={!enableVerifyButton || isVerified}
            variant={isVerified ? 'text' : 'outlined'}
            onClick={() => {
              if (!isVerified) {
                onSubmit(phoneNumber);
              }
            }}
            color='primary'
            sx={{
              width: '81px',
              height: '36px',
              padding: '1px 35px',
              borderRadius: '4px',
            }}
          >
            <Typography
              variant='subtitle1'
              color={(enableVerifyButton || isVerified) && 'primary'}
              sx={{
                fontSize: '14px',
                fontWeight: 550,
                textTransform: 'uppercase',
              }}
            >
              {loading ? <CircularProgress size={20} /> : isVerified ? 'Verified' : 'Verify'}
            </Typography>
          </Button>
        ),
      }}
    />
  );
};
